import englishFlagIcon from "../assets/generated/icon-language-en-v1.png";
import frenchFlagIcon from "../assets/generated/icon-language-fr-v1.png";
import type { Language } from "../i18n.js";

export function LanguageToggle({
  language,
  label,
  onChange,
}: {
  language: Language;
  label: string;
  onChange: (language: Language) => void;
}) {
  const french = language === "fr";

  return (
    <button
      aria-checked={french}
      aria-label={label}
      className="language-toggle"
      onClick={() => onChange(french ? "en" : "fr")}
      role="switch"
      type="button"
    >
      <img
        alt="English"
        className={`language-toggle-flag language-toggle-en${french ? "" : " is-active"}`}
        src={englishFlagIcon}
      />
      <img
        alt="Français"
        className={`language-toggle-flag language-toggle-fr${french ? " is-active" : ""}`}
        src={frenchFlagIcon}
      />
    </button>
  );
}
